export default __webpack_public_path__ + "6cf8aea5186b2f72546e0dbb7834676c.jpg";